window._define('widgets/ajaxForm', ['jquery', 'widgets/baseWidget'], function ($, BaseWidget) { 'use strict';

    $.widget('OC.ajaxForm', BaseWidget, {

        options: {
            classname: 'oc-form',
        },

        _create: function () {
            this._super();

            this.element.addClass(this.options.classname + '--ajax');

            this.loading = false;

            this._createLoadingOverlay();

            this._addEvents();
        },

        _createLoadingOverlay: function () {
            this.element.css('position', 'relative');

            this.elements.$overlay =
                $('<div>')
                    .addClass(this.options.classname + '__overlay');

            this.elements.$overlayText =
                $('<div>')
                    .html('<span><i class="icon-large icon-spinner icon-spin"></i> Chargement</span>')
                    .addClass(this.options.classname + '__overlay-text');

            this.elements.$inner =
                this.element
                    .find('> *')
                    .wrapAll('<div>')
                    .parent()
                    .addClass(this.options.classname + '__inner');

            this.elements.$overlayText
                .appendTo(this.elements.$overlay);

            this.elements.$overlay
                .appendTo(this.element);

        },

        _addEvents: function () {
            this._on(this.element, {
                'submit': this._onSubmit,
            });

            //            $('input', this.element).on('invalid', function (event) {
            //                event.preventDefault();
            //                console.log(arguments);
            //            });
        },

        _onSubmit: function (event) {
            event.preventDefault();
            this.submit();
        },

        setLoadingState: function (state) {
            this.loading = state;
            this.element.toggleClass(this.options.classname + '--loading', state);
        },

        submit: function () {
            var request,
                self = this,
                $form = this.element;

            // prevent multiple submits
            if (!this.loading) {
                request = $.post($form.attr('action'), $form.serialize());
                this.setLoadingState(true);

                request.done(function () {
                    self.setLoadingState(false);
                });

                this._trigger('submit', null, { request: request });
            }
        },

    });

    return $.OC.ajaxForm;

});
